import { ProfileHttpGateway } from 'src/adapters/http/ProfileHttpGateway'
import { GetCityInfo } from './GetCityInfo'
import { GetProfile } from './GetProfile'

// Сборка зависимостей вручную: гейтвей (вилка) вставляется в сценарии.
const profileGateway = new ProfileHttpGateway()

export const getProfile = new GetProfile(profileGateway)
export const getCityInfo = new GetCityInfo(profileGateway)
